import axios from "axios";
import { API_URL } from "config/Config";
import { generateTokenConfirmOrder } from "utils";
const customAxios = axios.create({
  baseURL: `${API_URL}v1/`, // URL mặc định của service
  headers: {
    Authorization: generateTokenConfirmOrder(),
  },
});

export const OrderConfirmServices = {
  confimReceived: (params) => {
    return customAxios.post(`update-bill-received/${params?.id}`, params);
  },
  confirmRecievedNow: (params) => {
    return customAxios.post(`update-bill-urgent/${params?.id}`, params);
  },
  confirmRecievedSchedule: (params) => {
    return customAxios.post(`update-bill-link-zns/${params?.id}`, params);
  },
  showBillZns: (params) => {
    return customAxios.get(`show-bill-zns/${params?.id}`);
  },
  confimIssueBill: (params) => {
    return customAxios.post(`update-bill-issue/${params?.id}`, params);
  }
  // confirmRecievedSchedule: (params) => {
  //   return customAxios.post(`update-bill-schedule/${params?.id}`, params);
  // },
};
